import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
	name: 'timezoneDate',
	standalone: true,
	pure: true // pure: true ensures the pipe is only recalculated when input changes
  })
  export class TimezoneDatePipe implements PipeTransform {
	transform(date: string, timezone: string): string {
		  // Parse the input date, treating it as UTC by removing the timezone offset

		  const utcDate  = new Date(date);

		  // Use Intl.DateTimeFormat for timezone conversion
		  const formatter = new Intl.DateTimeFormat("en-GB", {
			timeZone: timezone,
			year: "numeric",
			month: "2-digit",
			day: "2-digit",
			hour: "2-digit",
			minute: "2-digit",
			hour12: false,
		  });

		  // Format the date in the specified timezone
		  const parts = formatter.formatToParts(utcDate);

		  // Construct a formatted string from the parts
		  const formattedDate = `${parts.find(p => p.type === 'day')?.value}-${parts.find(p => p.type === 'month')?.value}-${parts.find(p => p.type === 'year')?.value} ${parts.find(p => p.type === 'hour')?.value}:${parts.find(p => p.type === 'minute')?.value}`;

		  return formattedDate;
	}
  }
